import { Role } from '@/generated/graphql';

export const HOME_ROUTE = '/';
export const LOGIN_ROUTE = '/login';
export const SIGNUP_ROUTE = '/signup';
export const FORGOT_PASSWORD_ROUTE = '/forgot-password';
export const ADMIN_ROUTE = '/admin';
export const FIRST_TIME_ROUTE = '/admin?new=true';
export const ACCOUNT_ROUTE = '/account';
export const RESET_PASSWORD_ROUTE = '/reset-password';
export const USERS_ROUTE = `${ADMIN_ROUTE}/users`;
export const SETTINGS_ROUTE = `${ADMIN_ROUTE}/settings`;
export const SCREENS_ROUTE = `${ADMIN_ROUTE}/screens`;
export const SCREEN_ROUTE = `${ADMIN_ROUTE}/screens/:id`;
export const SCREEN_SUB_ROUTE = `${SCREEN_ROUTE}/:section`;
export const SCREEN_CONFIG_ROUTE = `${SCREEN_ROUTE}/config`;
export const SCREEN_EDITOR_ROUTE = `${SCREEN_ROUTE}/editor`;
export const SCREEN_ENGAGEMENTS_ROUTE = `${SCREEN_ROUTE}/engagements`;
export const SCREEN_INSIGHTS_ROUTE = `${SCREEN_ROUTE}/insights`;
export const SCREEN_CONTROL_ROUTE = `${SCREEN_ROUTE}/control`;
export const SCREEN_MODERATION_ROUTE = `${SCREEN_ROUTE}/moderation`;
export const SCREEN_ENGAGEMENT_ROUTE = `${SCREEN_ENGAGEMENTS_ROUTE}/:engagementId`;
export const SUBMISSION_ROUTE = `${SCREEN_ENGAGEMENT_ROUTE}/submissions/:submissionId`;
export const TEMPLATES_ROUTE = `${ADMIN_ROUTE}/templates`;
export const DB_ROUTE = `${ADMIN_ROUTE}/db`;
export const BETA_SIGNUPS_ROUTE = `${ADMIN_ROUTE}/beta-signups`;

// Stage and fan routes
export const STAGE_ROUTE = '/stage/:id';
export const STAGE_CODE_ROUTE = '/stage';
export const FAN_ROUTE = '/e/:id';
export const QUICK_SIGNUP_ROUTE = '/quick-signup';
export const PRICING_ROUTE = '/pricing';
export const SUPPORT_ROUTE = '/support';
export const TRIVIA_PREVIEW_ROUTE = '/trivia-preview';
export const SLIDES_FREEFORM_PREVIEW_ROUTE = '/slides-freeform-preview';

export const HOME_ROUTES: Record<Role, string> = {
  ADMIN: ADMIN_ROUTE,
  USER: ADMIN_ROUTE,
  ANON: HOME_ROUTE,
};
